<template>
    <section class="about-section">
        <div class="section-container">
            <div class="about-content">
                <div class="about-text">
                    <h2 class="section-title left-aligned">关于 AutoSquare</h2>
                    <p class="about-lead">
                        “AutoSquare-动方科技”是一个致力于突破地质工程传统边界的创新团队。我们将硬核工程理论与现代软件工程相结合，为行业带来前所未有的数字化体验。
                    </p>
                    <p class="about-details">
                        在这个快速变化的数字化时代，地质工程的数据量和复杂性呈指数级增长。传统的分析工具已经难以满足当下对"精度"与"速度"的双重追求。
                        因此，我们成立了 AutoSquare，旨在用最现代化的前端交互和最高效的后端算法引擎，重新定义工程软件的标准。
                    </p>
                    <div class="stats-container">
                        <div class="stat-item">
                            <div class="stat-number">10+</div>
                            <div class="stat-label">行业顶级专家</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">5+</div>
                            <div class="stat-label">核心专利算法</div>
                        </div>
                        <div class="stat-item">
                            <div class="stat-number">200%</div>
                            <div class="stat-label">计算性能提升</div>
                        </div>
                    </div>
                </div>
                <div class="about-visual">
                    <div class="image-wrapper">
                        <div class="visual-placeholder">
                            <div class="grid-overlay"></div>
                            <img src="../assets/logo_big.png" alt="AutoSquare" class="about-logo" />
                        </div>
                        <div class="glass-card">
                            <div class="glass-icon">🚀</div>
                            <div class="glass-text">
                                <strong>驱动创新</strong><br>
                                Empowering Engineering
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'AboutSection'
}
</script>

<style scoped>
.about-section {
    background-color: var(--bg-color-secondary);
    border-top: 1px solid rgba(15, 23, 42, 0.05);
    position: relative;
    overflow: hidden;
}

.about-section::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.5));
    pointer-events: none;
}

.about-content {
    display: flex;
    align-items: center;
    gap: 5rem;
}

.about-text {
    flex: 1;
}

.section-title.left-aligned {
    text-align: left;
    margin-bottom: 2rem;
}

.section-title.left-aligned::after {
    left: 0;
    transform: none;
}

.about-lead {
    font-size: 1.25rem;
    color: var(--text-primary);
    line-height: 1.8;
    margin-bottom: 1.5rem;
    font-weight: 500;
}

.about-details {
    color: var(--text-secondary);
    line-height: 1.8;
    margin-bottom: 3rem;
    font-size: 1rem;
}

.stats-container {
    display: flex;
    gap: 3rem;
}

.stat-item {
    display: flex;
    flex-direction: column;
}

.stat-number {
    font-size: 2.5rem;
    font-weight: 800;
    color: var(--accent-color);
    margin-bottom: 0.2rem;
    background: linear-gradient(135deg, #2563eb 0%, #06b6d4 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

.stat-label {
    color: var(--text-secondary);
    font-size: 0.9rem;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.about-visual {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
}

.image-wrapper {
    position: relative;
    width: 100%;
    max-width: 500px;
    height: 450px;
    border-radius: 24px;
    background: linear-gradient(145deg, #f8fafc, #ffffff);
    border: 1px solid rgba(15, 23, 42, 0.05);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    justify-content: center;
}

.visual-placeholder {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    overflow: hidden;
}

.grid-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image:
        linear-gradient(rgba(37, 99, 235, 0.05) 1px, transparent 1px),
        linear-gradient(90deg, rgba(37, 99, 235, 0.05) 1px, transparent 1px);
    background-size: 30px 30px;
}

.about-logo {
    max-width: 60%;
    max-height: 40%;
    object-fit: contain;
    opacity: 1;
    filter: drop-shadow(0 0 20px rgba(37, 99, 235, 0.15));
    position: relative;
    z-index: 2;
}

.glass-card {
    position: absolute;
    bottom: -20px;
    right: -20px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(16px);
    -webkit-backdrop-filter: blur(16px);
    border: 1px solid rgba(255, 255, 255, 1);
    padding: 1.2rem 1.5rem;
    border-radius: 16px;
    display: flex;
    align-items: center;
    gap: 1rem;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
    z-index: 10;
}

.glass-icon {
    font-size: 2rem;
}

.glass-text {
    font-size: 0.9rem;
    color: var(--text-secondary);
    line-height: 1.4;
}

.glass-text strong {
    color: var(--text-primary);
    font-size: 1rem;
}

@media (max-width: 992px) {
    .about-section::before {
        display: none;
    }

    .about-content {
        flex-direction: column;
        gap: 2.5rem;
    }

    .section-title.left-aligned {
        text-align: center;
    }

    .section-title.left-aligned::after {
        left: 50%;
        transform: translateX(-50%);
    }

    .about-text {
        text-align: center;
    }

    .stats-container {
        justify-content: center;
        flex-wrap: wrap;
    }

    .glass-card {
        right: 50%;
        transform: translateX(50%);
        bottom: -30px;
    }
}

@media (max-width: 768px) {
    .image-wrapper {
        height: 220px;
        background: #ffffff;
        border: 1px solid rgba(15, 23, 42, 0.08);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    }

    .stats-container {
        flex-direction: column;
        gap: 1.5rem;
        align-items: center;
    }

    .stat-number {
        font-size: 2rem;
    }

    .about-lead {
        font-size: 1.1rem;
    }
}
</style>
